module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: ['vux-badge', {
      'vux-badge-dot': typeof _vm.text === 'undefined',
      'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1
    }],
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-131a0617"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/badge/index.vue
// module id = 189
// module chunks = 1